import React from 'react';
import { skillGroups } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function SkillsCloud({
  showLabel = true
}: {
  showLabel?: boolean;
}) {
  return <section id="skills" className="w-full bg-canvas py-20 lg:py-28" data-id="element-418" data-mp="23piyynceuya7">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-419" data-mp="28pdp2ood3ju7">
        {showLabel && <Reveal data-id="element-420" data-mp="1uy8va37odlrs">
            <SectionLabel data-id="element-421" data-mp="1uxpe4opun1et">Executive Skills</SectionLabel>
            <h2 className="mt-6 max-w-2xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-422" data-mp="1uw5watojoiax">
              Core competencies
            </h2>
          </Reveal>}

        <div className={`grid grid-cols-1 gap-10 lg:grid-cols-3 ${showLabel ? 'mt-14' : ''}`} data-id="element-423" data-mp="1pyw9llsjikqs">
          {skillGroups.map((group, index) => <Reveal key={group.category} delay={index * 0.07} data-id="element-424" data-mp="1c0o953wap1av" data-mpi={index}>
              <div className="flex h-full flex-col border-t-2 border-navy pt-6" data-id="element-425" data-mp="1g1hubpics202">
                <h3 className="text-[12px] font-semibold uppercase tracking-label text-navy" data-id="element-426" data-mp="jg6q5lb5be0p">
                  {group.category}
                </h3>
                <ul className="mt-6 flex flex-wrap gap-2.5" data-id="element-427" data-mp="egamjn6d1olo">
                  {group.skills.map(skill => <li key={skill} className="border border-line bg-white px-4 py-2.5 text-[14px] font-medium text-charcoal transition-colors duration-150 ease-premium hover:border-metal hover:text-navy" data-id="element-428" data-mp="tdl7ro8t28ul">
                      {skill}
                    </li>)}
                </ul>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}